<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { roundUp } from "../utility/roundUp";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChartNew",
  components: {
    Bar,
  },
  props: {
    labels: {
      type: Array,
    },
    datasets: {
      type: Array,
    },
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 50,
    },
    height: {
      type: Number,
      default: 200,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [ChartDataLabels],
    },
  },
  data() {
    this.datasets[0].data[0] = roundUp(this.datasets[0].data[0],2);
    this.datasets[0].data[1] = roundUp(this.datasets[0].data[1],2);
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets,
      },
      chartOptions: {
        scales:{
          x:{
             ticks: {
              font: {
                weight: 'bold'
              }
            },
          }
        },
        plugins: {
          legend: {
            display: false,
            align: "center",
            Title: {
              position: "center",
            },
          },
          datalabels: {
            formatter: function (value, context) {
              return roundUp(new Intl.NumberFormat("en-US").format(value),2) ;
            },
           
          },
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 27,
            bottom: 5,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
};
</script>
